import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {UsersService} from './users.service';

@Injectable({providedIn: 'root'})
export class UserRolesGuard implements CanActivate {

    private userRole: any;

    constructor(private auth: UsersService,
                private router: Router) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


        // check user roles and verify if includes expected roles, returns true or false
        return this.auth.getCurrentUser().toPromise().then((res: any) => {
            this.userRole = res.roles;

            // get all the roles you specify in page route
            const requiredPageRoles = route.data.allowedRoles;

            // check if there is any user role
            if (this.userRole !== null) {

                // if the ROLES you specify exist in USER ROLES array then allow the user to enter
                // else redirect to dashboard
                if (requiredPageRoles.some(v => this.userRole.includes(v))) {
                    return true;
                } else if (this.userRole.includes('ROLE_client')) {
                    return this.router.navigate(['/tickets/list']);
                } else {
                    return this.router.navigate(['/dashboard']);
                }

            } else {
                return this.router.navigate(['/dashboard']);
            }
            // if there is any error redirect to login
        }, error => this.router.navigate(['/auth/login'],));
    }
}
